import React, { useState } from 'react';
import { Card } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { commodities, commodityCategories, stockData } from '../../data/mockData';
import { Package, Search, TrendingUp, TrendingDown, AlertCircle } from 'lucide-react';
export function CommodityList() {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState<string>('all');
  // Calculate stock per commodity
  const commodityStats = commodities.map(commodity => {
    const stocks = stockData.filter(s => s.commodity === commodity);
    const totalQty = stocks.reduce((sum, s) => sum + s.quantity, 0);
    const availableQty = stocks.filter(s => s.status === 'Available').reduce((sum, s) => sum + s.quantity, 0);
    const blockedQty = stocks.filter(s => s.status === 'Blocked').reduce((sum, s) => sum + s.quantity, 0);
    return {
      name: commodity,
      totalQty,
      availableQty,
      blockedQty,
      lotCount: stocks.length,
      status: totalQty > 0 ? 'In Stock' : 'Out of Stock'
    };
  });
  const filteredCommodities = commodityStats.filter(c => c.name.toLowerCase().includes(searchTerm.toLowerCase()));
  return <div className="space-y-6" data-id="element-990">
      {/* Header */}
      <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4" data-id="element-991">
        <div data-id="element-992">
          <h1 className="text-2xl font-bold text-gray-900" data-id="element-993">
            Daftar Komoditas Pangan
          </h1>
          <p className="text-gray-500 mt-1" data-id="element-994">
            Semua komoditas yang ditangani BULOG
          </p>
        </div>
        <div className="flex gap-2 w-full lg:w-auto" data-id="element-995">
          <Button variant="outline" data-id="element-996">Export Excel</Button>
          <Button data-id="element-997">Tambah Komoditas</Button>
        </div>
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-998">
        <Card className="border-l-4 border-l-bulog-blue" data-id="element-999">
          <div className="flex items-center gap-4" data-id="element-1000">
            <div className="p-3 bg-blue-50 rounded-lg" data-id="element-1001">
              <Package className="text-bulog-blue" size={24} data-id="element-1002" />
            </div>
            <div data-id="element-1003">
              <p className="text-sm text-gray-500" data-id="element-1004">Total Komoditas</p>
              <p className="text-2xl font-bold text-gray-900" data-id="element-1005">
                {commodities.length}
              </p>
            </div>
          </div>
        </Card>

        <Card className="border-l-4 border-l-green-500" data-id="element-1006">
          <div className="flex items-center gap-4" data-id="element-1007">
            <div className="p-3 bg-green-50 rounded-lg" data-id="element-1008">
              <TrendingUp className="text-green-600" size={24} data-id="element-1009" />
            </div>
            <div data-id="element-1010">
              <p className="text-sm text-gray-500" data-id="element-1011">Tersedia Stok</p>
              <p className="text-2xl font-bold text-gray-900" data-id="element-1012">
                {commodityStats.filter(c => c.totalQty > 0).length}
              </p>
            </div>
          </div>
        </Card>

        <Card className="border-l-4 border-l-red-500" data-id="element-1013">
          <div className="flex items-center gap-4" data-id="element-1014">
            <div className="p-3 bg-red-50 rounded-lg" data-id="element-1015">
              <AlertCircle className="text-red-600" size={24} data-id="element-1016" />
            </div>
            <div data-id="element-1017">
              <p className="text-sm text-gray-500" data-id="element-1018">Stok Habis</p>
              <p className="text-2xl font-bold text-gray-900" data-id="element-1019">
                {commodityStats.filter(c => c.totalQty === 0).length}
              </p>
            </div>
          </div>
        </Card>

        <Card className="border-l-4 border-l-bulog-orange" data-id="element-1020">
          <div className="flex items-center gap-4" data-id="element-1021">
            <div className="p-3 bg-orange-50 rounded-lg" data-id="element-1022">
              <TrendingDown className="text-bulog-orange" size={24} data-id="element-1023" />
            </div>
            <div data-id="element-1024">
              <p className="text-sm text-gray-500" data-id="element-1025">Stok Diblokir</p>
              <p className="text-2xl font-bold text-gray-900" data-id="element-1026">
                {commodityStats.filter(c => c.blockedQty > 0).length}
              </p>
            </div>
          </div>
        </Card>
      </div>

      {/* Search & Filter */}
      <Card data-id="element-1027">
        <div className="flex flex-col sm:flex-row gap-4" data-id="element-1028">
          <div className="flex-1 relative" data-id="element-1029">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} data-id="element-1030" />
            <input type="text" placeholder="Cari komoditas..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-bulog-blue focus:border-transparent" data-id="element-1031" />
          </div>
          <div className="flex gap-2 overflow-x-auto pb-2" data-id="element-1032">
            <button onClick={() => setSelectedCategory('all')} className={`px-4 py-2 rounded-lg font-medium text-sm whitespace-nowrap transition-colors ${selectedCategory === 'all' ? 'bg-bulog-blue text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-1033">
              Semua ({commodities.length})
            </button>
            {Object.keys(commodityCategories).map(category => <button key={category} onClick={() => setSelectedCategory(category)} className={`px-4 py-2 rounded-lg font-medium text-sm whitespace-nowrap transition-colors ${selectedCategory === category ? 'bg-bulog-blue text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-1034">
                {category} (
                {commodityCategories[category as keyof typeof commodityCategories].length}
                )
              </button>)}
          </div>
        </div>
      </Card>

      {/* Commodity Categories */}
      {Object.entries(commodityCategories).map(([category, items]) => {
      if (selectedCategory !== 'all' && selectedCategory !== category) return null;
      const categoryStats = items.map(item => commodityStats.find(c => c.name === item)).filter(Boolean);
      return <Card key={category} title={category} description={`${items.length} komoditas`} data-id="element-1035">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-1036">
              {categoryStats.map((stat: any) => <div key={stat.name} className="p-4 border border-gray-200 rounded-lg hover:shadow-md transition-shadow cursor-pointer" data-id="element-1037">
                  <div className="flex items-start justify-between mb-3" data-id="element-1038">
                    <div className="flex-1 min-w-0" data-id="element-1039">
                      <h3 className="font-semibold text-gray-900 truncate" data-id="element-1040">
                        {stat.name}
                      </h3>
                      <p className="text-xs text-gray-500 mt-1" data-id="element-1041">
                        {stat.lotCount} lot tersedia
                      </p>
                    </div>
                    <Badge variant={stat.totalQty > 0 ? 'success' : 'default'} data-id="element-1042">
                      {stat.status}
                    </Badge>
                  </div>

                  <div className="space-y-2" data-id="element-1043">
                    <div className="flex justify-between text-sm" data-id="element-1044">
                      <span className="text-gray-600" data-id="element-1045">Total Stok:</span>
                      <span className="font-semibold text-gray-900" data-id="element-1046">
                        {stat.totalQty.toLocaleString()} ton
                      </span>
                    </div>
                    <div className="flex justify-between text-sm" data-id="element-1047">
                      <span className="text-gray-600" data-id="element-1048">Available:</span>
                      <span className="font-semibold text-green-600" data-id="element-1049">
                        {stat.availableQty.toLocaleString()} ton
                      </span>
                    </div>
                    {stat.blockedQty > 0 && <div className="flex justify-between text-sm" data-id="element-1050">
                        <span className="text-gray-600" data-id="element-1051">Blocked:</span>
                        <span className="font-semibold text-red-600" data-id="element-1052">
                          {stat.blockedQty.toLocaleString()} ton
                        </span>
                      </div>}
                  </div>

                  <div className="mt-3 pt-3 border-t border-gray-100" data-id="element-1053">
                    <div className="h-2 bg-gray-100 rounded-full overflow-hidden" data-id="element-1054">
                      <div className="h-full bg-bulog-blue rounded-full transition-all" style={{
                  width: `${stat.totalQty > 0 ? stat.availableQty / stat.totalQty * 100 : 0}%`
                }} data-id="element-1055" />
                    </div>
                    <p className="text-xs text-gray-500 mt-1 text-center" data-id="element-1056">
                      {stat.totalQty > 0 ? Math.round(stat.availableQty / stat.totalQty * 100) : 0}
                      % tersedia
                    </p>
                  </div>
                </div>)}
            </div>
          </Card>;
    })}

      {/* All Commodities List */}
      {selectedCategory === 'all' && <Card title="Semua Komoditas" description="Daftar lengkap komoditas BULOG" data-id="element-1057">
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3" data-id="element-1058">
            {filteredCommodities.map(commodity => <div key={commodity.name} className="p-3 border border-gray-200 rounded-lg hover:border-bulog-blue hover:shadow-sm transition-all cursor-pointer" data-id="element-1059">
                <div className="flex items-center gap-2 mb-2" data-id="element-1060">
                  <Package size={16} className="text-bulog-blue flex-shrink-0" data-id="element-1061" />
                  <h4 className="text-sm font-semibold text-gray-900 truncate" data-id="element-1062">
                    {commodity.name}
                  </h4>
                </div>
                <p className="text-xs text-gray-600" data-id="element-1063">
                  {commodity.totalQty.toLocaleString()} ton
                </p>
                <div className="mt-2" data-id="element-1064">
                  <Badge variant={commodity.totalQty > 0 ? 'success' : 'default'} className="text-xs" data-id="element-1065">
                    {commodity.status}
                  </Badge>
                </div>
              </div>)}
          </div>
        </Card>}
    </div>;
}